<div class="sir-container" (mouseleave)="onMouseLeave()">
    <div class="sir-navigation" #nav>
        <div>
            <sirius-navigation-menu-desktop
                [menuGroups]="menuGroups()"
                [siteRoot]="siteRoot()"
                [searchPageUrl]="searchPageUrl()"
                [logos]="logos()"
                [profileEnabled]="profileEnabled()"
                [profileMenuOptions]="profileMenuOptions()"
                [cartData]="cartData()"
                [ctaButton]="ctaButton()"
                [activeMenuIndex]="enteredMenuItem()"
                (profileClicked)="profileClicked.emit()"
                (menuItemEntered)="onMenuItemEntered($event)"
                (menuItemClicked)="onMenuItemClicked($event)"
                (mobileMenuToggle)="onMobileMenuToggle($event)">
            </sirius-navigation-menu-desktop>
            @if (dropdownOpen() && hasItems()) {
                @let activeIndex = enteredMenuItem();
                @if (activeIndex !== null) {
                    <sirius-navigation-menu-dropdown
                        [content]="menuGroups()[activeIndex]"
                        (clickEvent)="onDropdownClicked()">
                    </sirius-navigation-menu-dropdown>
                }
            }
            @if (mobileMenuOpen()) {
                <sirius-navigation-menu-mobile
                    [content]="menuGroups()"
                    (menuClose)="onMobileMenuToggle(false)">
                </sirius-navigation-menu-mobile>
            }
        </div>
    </div>
</div>
